import React from 'react';
import TodoSeriesList from '../Components/TodoSeriesList';

function TodoSeries() {
  return <TodoSeriesList />;
}

export default TodoSeries;
